/**
 * GraphQL queries and hooks — dataDomain pillar.
 * Split from graphql/queries.ts (issue #1409).
 */

import { gql } from '@apollo/client';
import { useQuery, type QueryResult } from '@apollo/client/react';
import type { DataDomain, DataDomainConnection, DataDomainFilter } from '../types/dataDomain';

export const DATA_DOMAIN_FIELDS = gql`
  fragment DataDomainFields on DataDomain {
    entityId
    entityType
    name
    description
    domainType
    dataStewardId
    owningBusinessUnitId
    technicalOwnerId
    defaultClassification
    containsPII
    containsPCI
    containsPHI
    complianceFrameworks
    retentionPeriodDays
    qualityScore
    lifecycleStatus
    criticalityLevel
    tags
    notes
    documentationUrl
    _schemaVersion
    _createdAt
    _createdBy
    _updatedAt
    _updatedBy
    _deletedAt
  }
`;

export const GET_DATA_DOMAIN = gql`
  ${DATA_DOMAIN_FIELDS}
  query GetDataDomain($id: ID!) {
    dataDomain(id: $id) {
      ...DataDomainFields
    }
  }
`;

export const LIST_DATA_DOMAINS = gql`
  ${DATA_DOMAIN_FIELDS}
  query ListDataDomains($filter: DataDomainFilter, $first: Int, $after: String) {
    dataDomains(filter: $filter, first: $first, after: $after) {
      edges {
        node {
          ...DataDomainFields
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export function useDataDomain(id: string): QueryResult<{ dataDomain: DataDomain | null }> {
  return useQuery(GET_DATA_DOMAIN, {
    variables: { id },
    skip: !id,
  });
}

export function useDataDomains(
  filter?: DataDomainFilter,
  first: number = 50
): QueryResult<{ dataDomains: DataDomainConnection }> {
  return useQuery(LIST_DATA_DOMAINS, {
    variables: { filter, first },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
  });
}
